export const squad: Record<number, string> = {
  0: "NONE",
  1: "ALPHA",
  2: "BRAVO",
  3: "CHARLIE",
  4: "DELTA",
  5: "ECHO",
  6: "FOXTROT",
  7: "GOLF",
  8: "HOTEL",
  9: "INDIA",
  10: "JULIET",
  11: "KILO",
  12: "LIMA",
  13: "MIKE",
  14: "NOVEMBER",
  15: "OSCAR",
  16: "PAPA",
  17: "QUEBEC",
  18: "ROMEO",
  19: "SIERRA",
  20: "TANGO",
  21: "UNIFORM",
  23: "VICTOR",
  24: "WHISKEY",
  25: "XRAY",
  26: "YANKEE",
  27: "ZULU",
  28: "HAGGARD",
  29: "SWEETWATER",
  30: "PRESTON",
  31: "REDFORD",
  32: "FAITH",
  33: "CELESTE",
}